import { InjectionToken } from '@angular/core';

export const CLOCK = new InjectionToken<() => Date>('time.clock', { providedIn: 'root', factory: () => () => new Date() });
